export {
  getDeviceId,
  getSessionId,
  identify,
  Identify,
  init,
  revenue,
  Revenue,
  add,
  setDeviceId,
  setOptOut,
  setSessionId,
  setUserId,
  track,
} from '@amplitude/analytics-browser';
